export type ResearchEventKind =
  | "status_update"
  | "tool_use"
  | "repl_turn"
  | "sub_lm_digest"
  | "citation_added"
  | "chunk_text"
  | "done"
  | "error";

export type VerbosityLevel = "quiet" | "progress" | "detailed" | "debug";

export const VERBOSITY_LEVELS: Record<VerbosityLevel, { shows: readonly ResearchEventKind[] | "*" }> = {
  quiet: { shows: ["status_update", "done", "error"] },
  progress: { shows: ["status_update", "tool_use", "done", "error"] },
  detailed: {
    shows: ["status_update", "tool_use", "sub_lm_digest", "repl_turn", "citation_added", "chunk_text", "done", "error"]
  },
  debug: { shows: "*" }
};

export function shouldShowEvent(level: VerbosityLevel, kind: ResearchEventKind): boolean {
  const shows = VERBOSITY_LEVELS[level].shows;
  return shows === "*" || shows.includes(kind);
}
